
import { motion } from 'framer-motion';
import { Loader } from 'lucide-react';

const LoadingFallback = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary text-primary-foreground">
      <motion.div
        animate={{ 
          opacity: [0.5, 1, 0.5],
          scale: [0.98, 1, 0.98]
        }}
        transition={{ 
          repeat: Infinity, 
          duration: 2 
        }}
        className="text-center"
      >
        <img 
          src="/lovable-uploads/27c0f0b8-cfa5-4ef4-b2dd-9c4589e4920f.png" 
          alt="Helfen FIDC" 
          className="w-64 h-auto mx-auto mb-6"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
        <p className="text-sm mb-6">Carregando conteúdo...</p>
        <Loader className="animate-spin h-6 w-6 mx-auto" />
      </motion.div>
    </div>
  );
};

export default LoadingFallback;
